import VerificationForm from "../components/VerificationForm";
import AppContext from "./AppContext";
import { useEffect, useState } from "react";
import { initialAppState } from "./AppContext";
import { StyleSheetManager } from "styled-components";
import isPropValid from "@emotion/is-prop-valid";

const App = () => {
  // state
  const [state, setState] = useState(initialAppState);
  const updateState = (newState) => {
    setState((prevState) => ({
      ...prevState,
      ...newState,
    }));
  };

  // plugin data
  useEffect(() => {
    updateState(window?.CVFPluginData);
  }, []);

  return (
    <AppContext.Provider value={{ ...state }}>
      <StyleSheetManager shouldForwardProp={isPropValid}>
        <VerificationForm />
      </StyleSheetManager>
    </AppContext.Provider>
  );
};
export default App;
